import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const StyledData = styled.td(() =>
  mq({
    width: '100%',
    height: '50px',
    fontSize: defaultTheme.font.size.s,
    verticalAlign: 'middle',
    textAlign: 'center',
    border: `solid ${defaultTheme.border.color.black}`,
    borderWidth: '1px 0',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '99%',
      borderRight: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    },
  }),
);
